import type { Eq } from "fp-ts/lib/Eq";

export function labeledEq<T extends { label: string }>(): Eq<T> {
  return {
    equals: (a, b) => a.label === b.label,
  };
}
